import PageNavigation from "@components/navigation/pageNavigation";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import {
  CurrencyEuroIcon,
  LocationMarkerIcon,
  OfficeBuildingIcon,
} from "@heroicons/react/solid";
import Link from "next/link";
import { useRouter } from "next/router";
import PageFooter from "@components/navigation/pageFooter";

export default function CareersPage({ careers }) {
  const router = useRouter();
  return (
    <>
      <PageNavigation />
      <main className="mt-10 c-container">
        {careers &&
          careers.data.map((job) => {
            return (
              <Link
                key={job.id}
                href="/careers/[jobId]"
                as={`/careers/${job.id}`}
                locale={router.locale}
              >
                <a className="flex flex-col justify-between w-full px-8 py-6 transition rounded bg-neutral-100 dark:bg-neutral-800 focus:outline-none hover:text-white hover:bg-default my-4">
                  <h1 className="text-xl font-semibold">
                    {job.attributes.name}
                  </h1>
                  <div>
                    <span className="inline-flex items-center pr-4 mt-2 text-sm font-semibold">
                      <OfficeBuildingIcon className="w-4 h-4 mr-1.5" />
                      Lptex
                    </span>
                    <span className="inline-flex items-center pr-4 mt-2 text-sm font-semibold">
                      <LocationMarkerIcon className="w-4 h-4 mr-1.5" />
                      Košice
                    </span>
                    <span className="inline-flex items-center mt-2 text-sm font-semibold">
                      <CurrencyEuroIcon className="w-4 h-4 mr-1.5" />
                      {job.attributes.pay}
                    </span>
                  </div>
                </a>
              </Link>
            );
          })}
      </main>
      <PageFooter />
    </>
  );
}
export async function getStaticProps({ locale }) {
  const baseUrl = process.env.STRAPI_URL;

  try {
    const responseCareers = await fetch(
      `${baseUrl}/api/careers?locale=${locale}&populate=*`,
      {
        headers: {
          Authorization: `Bearer ${process.env.STRAPI_KEY}`,
        },
      }
    );

    const careers = await responseCareers.json();

    return {
      props: {
        careers,
        baseUrl,
        ...(await serverSideTranslations(locale, ["common"])),
      },
      revalidate: 60,
    };
  } catch (error) {
    console.log(error);

    return null;
  }
}
